import { writable } from 'svelte/store';

function create_active_integrations() {
	const { subscribe, set, update } = writable([]);

	return {
		set,
		subscribe,
		reset: () => set([]),
		add: (el) => {
			update((active_integrations) => {
				const index = active_integrations.indexOf(el);
				if (index < 0) {
					active_integrations.push(el);
				}

				return active_integrations;
			});
		},
		remove: (el) =>
			update((active_integrations) => {
				const index = active_integrations.indexOf(el);
				if (index >= 0) {
					active_integrations.splice(index, 1);
				}
				return active_integrations;
			}),
	};
}

export const alexaInstalled = writable(false);
export const active_integrations = create_active_integrations();

/**
 * Write what kind of Alexa Skill we are trying to link
 * required parameter for all PHP request linked to this process
 */
export const skill_stage = writable(JSON.parse(localStorage.getItem('skill_stage')) || '');
skill_stage.subscribe((val) => localStorage.setItem('skill_stage', JSON.stringify(val)));

export const go_to = writable(null);
